@if (true) {
<div [ngClass]="{
    'video-list': true,
    'video-list--single': activeLayout === availableLayouts.single,
    'video-list--double': activeLayout === availableLayouts.double,
    'video-list--triple': activeLayout === availableLayouts.triple
  }"
    data-private
    >
    <audio #localAudioElement id="localAudio" autoplay></audio>
    <div class="video-container" (mouseenter)="showRecText()"
      (mouseleave)="hideRecText()">
      @if ((isRecordingActive$ | async) === true) {
        <div class="red-dot"></div>
      }
      @if (showRecordingText === true && (isRecordingActive$ | async) === true) {
        <span class="rec-text"
        >Recording...</span>
      }
      <video #localVideoElement class="video-feeds" autoplay></video>
      <canvas #canvasElement style="display: none;"></canvas>
    </div>
    @for (tile of remoteVideoTiles; track tile) {
      <div class="video-container">
        <video class="video-feeds" id="video-{{tile}}" autoplay></video>
        <audio id="audio-{{tile}}" autoplay></audio>
      </div>
    }
  </div>
}
